"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Calendar } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ScheduleYourFreeDemo() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223371" id="richiedi-accesso-ai-corridoi-digitali-csi" className="relative isolate overflow-hidden bg-background py-24 sm:py-32">
      {}
      <div className="absolute -top-24 -right-24 -z-10 h-[400px] w-[400px] sm:h-[600px] sm:w-[600px] transform-gpu rounded-full bg-secondary/20 blur-3xl opacity-30" aria-hidden="true" />
      {}
      <div className="absolute -bottom-24 -left-24 -z-10 h-[300px] w-[300px] transform-gpu rounded-full bg-primary/10 blur-3xl opacity-20" aria-hidden="true" />

      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div ref={ref} className={`mx-auto max-w-2xl text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-4xl font-bold tracking-tighter text-foreground sm:text-5xl font-default uppercase">
            Richiedi Accesso ai Corridoi Digitali CSI
          </h2>
          <p className="mt-6 text-lg leading-8 text-muted-foreground font-sans">
            Inizia la tua espansione nel mercato RuNet con un'infrastruttura SEO nativa e conforme.
          </p>
          <div className="mt-10 flex items-center justify-center gap-x-6">
            <Button size="lg" asChild className="rounded-none px-8 h-12 text-base bg-primary text-primary-foreground hover:bg-primary/90 shadow-lg shadow-primary/20">
              <Link to="/ContactPage">
                <SafeHydrate><Calendar className="mr-2 h-5 w-5" /></SafeHydrate>
                Configura Accesso Strategico
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}